import React, { useState, useCallback, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import { SlideUpTransition } from '../../Transitions/Transitions';
import BaseDialog from '../BaseDialog';
import { InvoiceHelpType } from '../../../Enums/invoices';

import CouponHelp from '../../../Assets/images/invoice_coupon_help_v2.png';
import ContractHelp from '../../../Assets/images/invoice_contract_help_v2.png';
import InvoiceNumberHelp from '../../../Assets/images/invoice_number_period_help_v2.png';
import SubrogationContractHelp from '../../../Assets/images/subrogation-contract-help.png';

const HelpImage = {
  [InvoiceHelpType.Contract]: ContractHelp,
  [InvoiceHelpType.Coupon]: CouponHelp,
  [InvoiceHelpType.Subrogation]: SubrogationContractHelp,
  [InvoiceHelpType.Invoice]: InvoiceNumberHelp
};

function InvoiceHelpDialogGDC(props) {
  const { open = true, onClose, type, title = 'Título' } = props;
  const classes = useStyles();

  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState('');

  const onImageLoaded = useCallback(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);
  }, [type]);

  useEffect(() => {
    setImage(HelpImage[type]);
  }, [type]);

  const renderContent = () => {
    return (
      <>
        <img
          className={classes.image}
          src={image}
          alt={`${type} help`}
          onLoad={onImageLoaded}
        />
      </>
    );
  };

  const isMobileSize = useMediaQuery(theme => theme.breakpoints.down('xs'));
  return (
    <BaseDialog
      open={open}
      loading={loading}
      handleClose={onClose}
      title={title}
      actions={() => null}
      content={renderContent}
      fullScreen={isMobileSize}
      TransitionComponent={isMobileSize ? SlideUpTransition : undefined}
      contentStyle={classes.dialogContent}
    />
  );
}

const useStyles = makeStyles(theme => ({
  image: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 580,
      height: 270
    }
  },
  dialogContent: {
    padding: theme.spacing()
  }
}));

export default InvoiceHelpDialogGDC;
